// extracted by mini-css-extract-plugin
module.exports = {"yesBtn":"ZC_w-","noBtn":"_3CpEQ"};